import { render } from "./paymentform.vue?vue&type=template&id=8be9dbdc&scoped=true"
import script from "./paymentform.vue?vue&type=script&lang=js"
export * from "./paymentform.vue?vue&type=script&lang=js"

import "./paymentform.vue?vue&type=style&index=0&id=8be9dbdc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be9dbdc"]])

export default __exports__